import { Validators, FormGroup, FormControl } from '@angular/forms';

export enum LoginFields {
    Email = 'Email',
    Password = 'Password'
}

export interface LoginForm {
    [LoginFields.Email]: FormControl<string>
    [LoginFields.Password]: FormControl<string>
}


export const generateLoginForm = (): FormGroup<LoginForm> => {
    return new FormGroup<LoginForm>({
        [LoginFields.Email]: new FormControl('', {nonNullable: true, validators: [Validators.required, Validators.email]}),
        [LoginFields.Password]: new FormControl('', {nonNullable: true, validators: [Validators.required]} )
    });
};
